// extracted by mini-css-extract-plugin
export default {"directory_link":"TableView_directory_link__-vuoA","link":"TableView_link__WE9Im"};